import script from "./MobileHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileHome.vue?vue&type=script&setup=true&lang=ts"

import "./MobileHome.vue?vue&type=style&index=0&id=1845691c&lang=less&scoped=true"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1845691c"]])

export default __exports__